import styled, { css } from 'styled-components';
import { MEDIA_QUERY } from '@optimus-web/breakpoints';
import { FOCUS_OUTLINE_STYLE, getSpacingToken, getToken } from '@optimus-web/common';
import { VIRTUALIZER_ITEMS_COMPONENT } from '@optimus-web/helpers';
import { DropdownItemContainer } from '../../../DropdownItem/style';

export const EmptyMessage = styled.div`
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

// Define the virtualized styles separately for better specificity
const virtualizedStyles = css`
    overflow-y: hidden;

    ${DropdownItemContainer} {
        margin-top: ${getSpacingToken('50')}px;
    }

    [data-component='${VIRTUALIZER_ITEMS_COMPONENT}'] {
        padding: ${getSpacingToken('50')}px ${getSpacingToken('100')}px ${getSpacingToken('100')}px;

        ${MEDIA_QUERY.tabletUp} {
            padding: ${getSpacingToken('50')}px ${getSpacingToken('100')}px ${getSpacingToken('100')}px;
        }
    }
`;

// Define the non-virtualized styles separately
const nonVirtualizedStyles = css`
    overflow-y: auto;
    padding: ${getSpacingToken('100')}px;

    & > div + div {
        margin-top: ${getSpacingToken('50')}px;
    }
`;

export const SelectListContainer = styled.div<{ virtualized?: boolean; selectAll?: boolean; readOnly?: boolean }>`
    padding: 0;
    position: relative;
    text-align: left;
    box-sizing: border-box;
    outline: none;
    width: 100%;
    color: ${getToken('textStaticPrimary')};
    background-color: ${getToken('backgroundStaticFlat')};

    /* Focus-visible styling for listbox accessibility */
    &:focus-visible {
        ${FOCUS_OUTLINE_STYLE}
        outline-offset: -${getSpacingToken('25')}px;
        border-radius: ${getToken('borderRadius100')}px;
    }

    /* Handle group separators visibility directly with CSS */
    & > [role='group'] {
        ${({ selectAll, readOnly }) => css`
            &: ${selectAll && !readOnly ? 'nth-of-type(2)' : 'first-of-type'} {
                & > [data-container='separator'] {
                    display: none;
                }
            }
        `}
    }

    ${({ virtualized }) =>
        // Apply styles based on virtualization state
        virtualized ? virtualizedStyles : nonVirtualizedStyles}
`;
